import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';

const Profile = lazy(() => import('modules/auth/Profile'));
const UserChangePassword = lazy(() =>
  import('modules/auth/UserChangePassword')
);

export const authRoutes = [
  {
    path: routePath.PROFILE,
    component: Profile,
    exact: true,
    name: routeName.PROFILE,
  },
  {
    path: routePath.CHANGE_PASSWORD,
    component: UserChangePassword,
    exact: true,
    name: routeName.CHANGE_PASSWORD,
  },
];
